import React, { Component } from "react";
import { connect } from "react-redux";
import {  Button } from "reactstrap";
import Loader from "react-loaders";
import { ToastContainer } from "react-toastify";
import { showErrorToast } from "../Components/Toaster";
import { References } from "../../constant/references";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import GeneList from "../Components/GeneList "
const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice,
  };
};

class CharacteristicsOfPatientResponders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCancerType: null,
      drugName: "",
      resultOptions: [],
      showDetails: false,
      cancerTypeOptions: [],
      drugSuggestions: [],
      filteredSuggestions: [],
      isAvailableInProject_1: false,
      drugBasicDetails: {
        drugTitle: "",
        diseaseDrugId: "",
        cancerType: "",
        histological_subtype: "",
      },
      respondermRna: [],
      respondergenes: [],
      openErrorPopup: false,
      RMA_data: {
        excels: [],
        images: [],
      },
      filterReference: [],
      materialsMethodsContent: "",
      CPRGeneData: {
        mRNA_Resistant: [],
        mRNA_Sensitive: [],
        CNV_amp_Resistant: [],
        CNV_amp_Sensitive: [],
        CNV_del_Resistant: [],
        CNV_del_Sensitive: [],
        mutation_Resistant: [],
        mutation_Sensitive: [],
        fusion_Resistant: [],
        fusion_Sensitive: [],
        methylation_Resistant: [],
        methylation_Sensitive: [],
        miRNA_Resistant: [],
        miRNA_Sensitive: [],
        mRNA_Resistant_Expanded: [],
        mRNA_Sensitive_Expanded: [],
        CNV_amp_Resistant_Expanded: [],
        CNV_amp_Sensitive_Expanded: [],
        CNV_del_Resistant_Expanded: [],
        CNV_del_Sensitive_Expanded: [],
        mutation_Resistant_Expanded: [],
        mutation_Sensitive_Expanded: [],
        fusion_Resistant_Expanded: [],
        fusion_Sensitive_Expanded: [],
        methylation_Resistant_Expanded: [],
        methylation_Sensitive_Expanded: [],
      },
      drugData: [],
      CPRData: [],
    imagesLoaded: false,
    base64Images: [],
    };
    this.suggestionBoxRef = React.createRef();
  }

  componentDidMount() {
      this.fetchCharacteristicsOfPatient()
  }



  fetchCharacteristicsOfPatient = () => {
        const drugInfoRes = this.props.drugInformation
        let up_mo_aid = [],
          down_mo_aid = [],
          mRNA_Resistant = [],
          mRNA_Sensitive = [],
          CNV_amp_Resistant = [],
          CNV_amp_Sensitive = [],
          CNV_del_Resistant = [],
          CNV_del_Sensitive = [],
          methylation_Resistant = [],
          methylation_Sensitive = [],
          miRNA_Sensitive = [],
          miRNA_Resistant = [],
          mutation_Resistant = [],
          mutation_Sensitive = [],
          fusion_Resistant = [],
          fusion_Sensitive = [],
          mRNA_Resistant_Expanded = [],
          mRNA_Sensitive_Expanded = [],
          CNV_amp_Resistant_Expanded = [],
          CNV_amp_Sensitive_Expanded = [],
          CNV_del_Resistant_Expanded = [],
          CNV_del_Sensitive_Expanded = [],
          mutation_Resistant_Expanded = [],
          mutation_Sensitive_Expanded = [],
          fusion_Resistant_Expanded = [],
          fusion_Sensitive_Expanded = [],
          methylation_Resistant_Expanded = [],
          methylation_Sensitive_Expanded = [];

        if (drugInfoRes?.data?.responder_genes?.length > 0) {
          for (let i = 0; i < drugInfoRes?.data?.responder_genes?.length; i++) {
            if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "mRNA&protein" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Resistant" &&
              drugInfoRes?.data?.responder_genes[i]?.expanded ===
                "0"
            ) {
              
              mRNA_Resistant.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "mRNA&protein" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Sensitive" &&
              drugInfoRes?.data?.responder_genes[i]?.expanded ===
                "0"
            ) {
              mRNA_Sensitive.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "CNV_amp" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Resistant" &&
              drugInfoRes?.data?.responder_genes[i]?.expanded ===
                "0"
            ) {
              CNV_amp_Resistant.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "CNV_amp" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Sensitive" &&
              drugInfoRes?.data?.responder_genes[i]?.expanded ===
                "0"
            ) {
              CNV_amp_Sensitive.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "CNV_del" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Resistant" &&
              drugInfoRes?.data?.responder_genes[i]?.expanded ===
                "0"
            ) {
              CNV_del_Resistant.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "CNV_del" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Sensitive" &&
              drugInfoRes?.data?.responder_genes[i]?.expanded ===
                "0"
            ) {
              CNV_del_Sensitive.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "methylation" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Resistant" &&
              drugInfoRes?.data?.responder_genes[i]?.expanded ===
                "0"
            ) {
              methylation_Resistant.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "methylation" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Sensitive" &&
              drugInfoRes?.data?.responder_genes[i]?.expanded ===
                "0"
            ) {
              methylation_Sensitive.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "mutation" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Resistant" &&
              drugInfoRes?.data?.responder_genes[i]?.expanded ===
                "0"
            ) {
              mutation_Resistant.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "mutation" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Sensitive" &&
              drugInfoRes?.data?.responder_genes[i]?.expanded ===
                "0"
            ) {
              mutation_Sensitive.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "fusion" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Resistant" &&
              drugInfoRes?.data?.responder_genes[i]?.expanded ===
                "0"
            ) {
              fusion_Resistant.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "fusion" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Sensitive" &&
              drugInfoRes?.data?.responder_genes[i]?.expanded ===
                "0"
            ) {
              fusion_Sensitive.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            }

            if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "mRNA&protein" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Resistant"
            ) {
              mRNA_Resistant_Expanded.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "mRNA&protein" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Sensitive"
            ) {
              mRNA_Sensitive_Expanded.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "CNV_amp" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Resistant"
            ) {
              CNV_amp_Resistant_Expanded.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "CNV_amp" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Sensitive"
            ) {
              CNV_amp_Sensitive_Expanded.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "CNV_del" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Resistant"
            ) {
              CNV_del_Resistant_Expanded.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "CNV_del" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Sensitive"
            ) {
              CNV_del_Sensitive_Expanded.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "methylation" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Resistant"
            ) {
              methylation_Resistant_Expanded.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "methylation" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Sensitive"
            ) {
              methylation_Sensitive_Expanded.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "mutation" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Resistant"
            ) {
              mutation_Resistant_Expanded.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "mutation" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Sensitive"
            ) {
              mutation_Sensitive_Expanded.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "fusion" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Resistant"
            ) {
              fusion_Resistant_Expanded.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            } else if (
              drugInfoRes?.data?.responder_genes[i]?.level ===
                "fusion" &&
              drugInfoRes?.data?.responder_genes[i]
                ?.resistant_sensitive === "Sensitive"
            ) {
              fusion_Sensitive_Expanded.push(
                drugInfoRes?.data?.responder_genes[i]?.geneName
              );
            }
          }
        }
        if (drugInfoRes?.data?.responder_mi_rnas?.length > 0) {
          for (
            let i = 0;
            i < drugInfoRes?.data?.responder_mi_rnas?.length;
            i++
          ) {
            if (
              drugInfoRes?.data?.responder_mi_rnas[i]
                ?.resistant_sensitive === "Resistant"
            ) {
              miRNA_Resistant.push(
                drugInfoRes?.data?.responder_mi_rnas[i]?.miRNAName
              );
            } else if (
              drugInfoRes?.data?.responder_mi_rnas[i]
                ?.resistant_sensitive === "Sensitive"
            ) {
              miRNA_Sensitive.push(
                drugInfoRes?.data?.responder_mi_rnas[i]?.miRNAName
              );
            }
          }
        }

        this.setState(
          (prevState) => {
            return {
               drugData: drugInfoRes?.data,
              upRegulated: up_mo_aid,
              downRegulated: down_mo_aid,
              CPRGeneData: {
                ...prevState.CPRGeneData,
                mRNA_Resistant: mRNA_Resistant,
                mRNA_Sensitive: mRNA_Sensitive,
                CNV_amp_Resistant: CNV_amp_Resistant,
                CNV_amp_Sensitive: CNV_amp_Sensitive,
                CNV_del_Resistant: CNV_del_Resistant,
                CNV_del_Sensitive: CNV_del_Sensitive,
                mutation_Resistant: mutation_Resistant,
                mutation_Sensitive: mutation_Sensitive,
                fusion_Resistant: fusion_Resistant,
                fusion_Sensitive: fusion_Sensitive,
                methylation_Resistant: methylation_Resistant,
                methylation_Sensitive: methylation_Sensitive,
                miRNA_Resistant: miRNA_Resistant,
                miRNA_Sensitive: miRNA_Sensitive,
                mRNA_Resistant_Expanded:
                  mRNA_Resistant_Expanded?.length > 0
                    ? mRNA_Resistant_Expanded?.toString()
                    : "N/A",
                mRNA_Sensitive_Expanded:
                  mRNA_Sensitive_Expanded?.length > 0
                    ? mRNA_Sensitive_Expanded?.toString()
                    : "N/A",
                CNV_amp_Resistant_Expanded:
                  CNV_amp_Resistant_Expanded?.length > 0
                    ? CNV_amp_Resistant_Expanded?.toString()
                    : "N/A",
                CNV_amp_Sensitive_Expanded:
                  CNV_amp_Sensitive_Expanded?.length > 0
                    ? CNV_amp_Sensitive_Expanded?.toString()
                    : "N/A",
                CNV_del_Resistant_Expanded:
                  CNV_del_Resistant_Expanded?.length > 0
                    ? CNV_del_Resistant_Expanded?.toString()
                    : "N/A",
                CNV_del_Sensitive_Expanded:
                  CNV_del_Sensitive_Expanded?.length > 0
                    ? CNV_del_Sensitive_Expanded?.toString()
                    : "N/A",
                methylation_Resistant_Expanded:
                  methylation_Resistant_Expanded?.length > 0
                    ? methylation_Resistant_Expanded?.toString()
                    : "N/A",
                methylation_Sensitive_Expanded:
                  methylation_Sensitive_Expanded?.length > 0
                    ? methylation_Sensitive_Expanded?.toString()
                    : "N/A",
                mutation_Resistant_Expanded:
                  mutation_Resistant_Expanded?.length > 0
                    ? mutation_Resistant_Expanded?.toString()
                    : "N/A",
                mutation_Sensitive_Expanded:
                  mutation_Sensitive_Expanded?.length > 0
                    ? mutation_Sensitive_Expanded?.toString()
                    : "N/A",
                fusion_Resistant_Expanded:
                  fusion_Resistant_Expanded?.length > 0
                    ? fusion_Resistant_Expanded?.toString()
                    : "N/A",
                fusion_Sensitive_Expanded:
                  fusion_Sensitive_Expanded?.length > 0
                    ? fusion_Sensitive_Expanded?.toString()
                    : "N/A",
              },
              CPRData:
                drugInfoRes?.data?.mi_rna_targeted_genes
                   || [],
              // imagesLoaded: false,
              loader: false,
            };
          },
          () => {
             this.loadImages();
             this.convertImagesToBase64();
          }
        );
  };

    async loadImages() {

        const imageObjects = this?.state?.CPRData
            .filter(item => item.expanded_y.toLowerCase() === 'yes')
            .map(item => ({
                url: `${item.miRNAtargetedGenes_img.url}`,
                description: item.description
            }));



        const promises = imageObjects?.map(obj =>
            this.toDataURL(obj.url).then(dataURL => ({
                base64: dataURL,
                description: obj.description
            }))
        );

        const base64Images = await Promise.all(promises);

        this.setState({ base64Images, imagesLoaded: true });

    }

  
    toDataURL = (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL('image/png'));
            };
            img.onerror = (error) => {
                reject(`Error loading image from URL: ${url}. Error: ${error.message}`);
            };
            img.src = url;
        });
    }

    convertImagesToBase64 = async () => {
        const {  CPRData } = this.state;

        const convertImages = async (data, key) => {
            return Promise.all(data.map(async (item) => {
                let imgUrl = '';
                if (key === 'drugData_img') {
                    imgUrl = item?.attributes?.chemStruct?.data?.attributes?.url
                } else if (key === 'miRNAtargetedGenes_img') {
                    imgUrl = item?.miRNAtargetedGenes_img?.url
                } 
                try {
                    const base64 = await this.toDataURL(imgUrl); // Adjust the key if necessary
                    return { ...item, base64 }
                        ;
                } catch (error) {
                    console.error('Error converting image to base64:', error);
                    return { ...item, base64: '' }; // Provide fallback or placeholder
                }
            }));
        };


        try {

            const CPRDataWithBase64 = await convertImages(CPRData, 'miRNAtargetedGenes_img');
            this.setState({

                CPRData: CPRDataWithBase64,
                imagesLoaded: true
            })
        } catch (error) {
            console.error('Error converting images:', error);
            this.setState({ imagesLoaded: true });
        }
    }


  exportPdf = async () => {
    if (!this.state.imagesLoaded) {
      console.error('Images are not loaded yet.');
      return;
    }

    this.setState({ loader: true });
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;
    const effectivePageHeight = pageHeight - 2 * margin;

    const contentHTML = this.getContentHTML();
    const hiddenContainer = document.createElement('div');
    hiddenContainer.style.width = '210mm'; // A4 width in mm
    hiddenContainer.style.position = 'absolute';
    hiddenContainer.style.top = '-9999px';
    hiddenContainer.innerHTML = contentHTML;
    document.body.appendChild(hiddenContainer);

    const elements = hiddenContainer.children;
    let yOffset = margin;


    for (const element of elements) {
      const elementHeight = element.offsetHeight * 0.264583; // Convert px to mm (96 DPI)

      if (elementHeight > effectivePageHeight) {
        // Element is too large, so break it down
        let partOffset = 0;
        while (partOffset < elementHeight) {
          if (yOffset + effectivePageHeight > pageHeight) {
            pdf.addPage();
            yOffset = margin;
          }

          const canvas = await html2canvas(element, {
            useCORS: true,
            allowTaint: true,
            scale: 2,
            height: effectivePageHeight * 3.78,
            y: partOffset * 3.78
          });

          const imgData = canvas.toDataURL('image/png');
          const imgWidth = pageWidth - 2 * margin;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          pdf.addImage(imgData, 'PNG', margin, yOffset, imgWidth, imgHeight);
          yOffset += effectivePageHeight;
          partOffset += effectivePageHeight;
        }
      } else {
        if (yOffset + elementHeight > effectivePageHeight) {
          pdf.addPage();
          yOffset = margin;
        }

        const canvas = await html2canvas(element, {
          useCORS: true,
          allowTaint: true,
          scale: 2
        });

        const imgData = canvas.toDataURL('image/png');
        const imgWidth = pageWidth - 2 * margin;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, 'PNG', margin, yOffset, imgWidth, imgHeight);
        yOffset += elementHeight;
      }
    }
    document.body.removeChild(hiddenContainer);
    pdf.save(`Expanded Gene List- ${this.props.drugDetails.drugTitle ?? ''}-${this.props.drugDetails.diseaseDrugId ?? ''}.pdf`);
    this.setState({ loader: false });

  }

   getContentHTML() {
     const mRNA_Resistant_Expanded = this.state?.CPRGeneData?.mRNA_Resistant_Expanded != 'N/A' || this.state?.CPRGeneData?.mRNA_Sensitive_Expanded != 'N/A';
    const CNV_amp_Resistant_Expanded = this.state?.CPRGeneData?.CNV_amp_Resistant_Expanded != 'N/A' || this.state?.CPRGeneData?.CNV_amp_Sensitive_Expanded != 'N/A' || this.state?.CPRGeneData?.CNV_del_Resistant_Expanded != 'N/A' || this.state?.CPRGeneData?.CNV_del_Sensitive_Expanded != 'N/A';
    const mutation_Resistant_Expanded = this.state?.CPRGeneData?.mutation_Resistant_Expanded != 'N/A' || this.state?.CPRGeneData?.mutation_Sensitive_Expanded != 'N/A';
    const methylation_Resistant_Expanded = this.state?.CPRGeneData?.methylation_Resistant_Expanded != 'N/A' || this.state?.CPRGeneData?.methylation_Sensitive_Expanded != 'N/A';
    const fusion_Resistant_Expanded = this.state?.CPRGeneData?.fusion_Resistant_Expanded != 'N/A' || this.state?.CPRGeneData?.fusion_Sensitive_Expanded != 'N/A';
    const miRNAResistantData = this.state?.CPRGeneData?.miRNA_Resistant?.length > 0 ? this.state?.CPRGeneData?.miRNA_Resistant : 'N/A';
    const miRNASensitiveData = this.state?.CPRGeneData?.miRNA_Sensitive?.length > 0 ? this.state?.CPRGeneData?.miRNA_Sensitive : 'N/A';

  return [
    `<p style="font-family:'Arial',sans-serif; font-weight: bold; font-size: 14px; ">Drug Sensitivity Classification : </p>
      <p style="font-family:'Arial',sans-serif; font-size: 12px ">
        Cell lines were classified as resistant if their half-maximal inhibitory concentration (IC50) or half-maximal effective concentration (EC50) values of the studied drug exceeded the maximum dose (10 µm); conversely cell lines were classified as sensitive if their IC50 or EC50 values of the studied drug were below the minimum dose (0.0006 µm). Utilizing the mean ± 0.5 standard deviations of the drug sensitivity measurements the remaining cell lines were categorized into three groups: sensitive, partial response, or resistant (Ye Mohamed et al. 2021; Ye Singh et al. 2021).
      </p>`,
    
    `<p style="font-family:'Arial',sans-serif; font-weight: bold; font-size: 14px; text-decoration: underline;" >Genes Associated with Drug Sensitivity and Resistance</p>`,
    
    mRNA_Resistant_Expanded ? `
      <div>
        <div style="font-family:'Arial',sans-serif; font-size: 12px; text-decoration: underline; font-weight: bold;">Genes with concordant mRNA and protein expression:</div>
        <div style="font-family:'Arial',sans-serif; font-size: 12px;">Resistant genes were expressed significantly higher at both mRNA and protein level (p < 0.05; two-sample t-tests) in resistant versus sensitive NSCLC cell lines. Similarly, sensitive genes were expressed significantly higher at both mRNA and protein level (p < 0.05; two-sample t-tests) in sensitive versus resistant NSCLC cell lines (DepMap 2023; Nusinow et al. 2020).</div>
      </div>` : '',
    
    mRNA_Resistant_Expanded ? `
      <table style="width: 100%; border-collapse: collapse; word-wrap: break-word; table-layout: fixed;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px; font-weight: bold; max-width: 50%; overflow-wrap: break-word;">Resistant Genes</th>
            <th style="border: 1px solid black; padding: 8px; font-weight: bold; max-width: 50%; overflow-wrap: break-word;">Sensitive Genes</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="border: 1px solid black; padding: 8px; max-width: 50%; overflow-wrap: break-word;">${this.state?.CPRGeneData?.mRNA_Resistant_Expanded}</td>
            <td style="border: 1px solid black; padding: 8px; max-width: 50%; overflow-wrap: break-word;">${this.state?.CPRGeneData?.mRNA_Sensitive_Expanded}</td>
          </tr>
        </tbody>
      </table>` : '',
    
    CNV_amp_Resistant_Expanded ? `
      <div>
        <div style="font-family:'Arial',sans-serif; font-size: 12px; text-decoration: underline; font-weight: bold;">DNA Copy Number Variation:</div>
        <div style="font-family:'Arial',sans-serif; font-size: 12px;">Resistant genes were 1) amplified, 2) expressed significantly higher at mRNA or protein level with no conflict in resistant NSCLC cell lines. Similarly, sensitive genes were 1) amplified, 2) expressed significantly higher at mRNA or protein level with no conflict in sensitive NSCLC cell lines (DepMap 2023; Nusinow et al. 2020). Copy number values were represented as log2(copy number ratio + 1). The data were further categorized into amplification (copy number ratio ≥ 1.5), deletion (copy number ratio ≤ 0.5), and normal (0.5 < copy number ratio < 1.5). DNA copy number variations associated with drug sensitivity were identified based on two criteria: 1) for continuous copy number data, significant difference in sensitive versus resistant NSCLC cell lines (p < 0.05; two-sample t-tests), and 2) for categorized copy number data, significant association between amplification/deletion and drug sensitivity/resistance (p < 0.05, Chi-squared tests).</div>
      </div>` : '',
    
    CNV_amp_Resistant_Expanded ? `
      <table style="width: 100%; border-collapse: collapse; word-wrap: break-word; table-layout: fixed;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px;">CNV</th>
            <th style="border: 1px solid black; padding: 8px;">Resistant Genes</th>
            <th style="border: 1px solid black; padding: 8px;">Sensitive Genes</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="border: 1px solid black; padding: 8px;">Amplification</td>
            <td style="border: 1px solid black; padding: 8px;">${this.state?.CPRGeneData?.CNV_amp_Resistant_Expanded}</td>
            <td style="border: 1px solid black; padding: 8px;">${this.state?.CPRGeneData?.CNV_amp_Sensitive_Expanded}</td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 8px;">Deletion</td>
            <td style="border: 1px solid black; padding: 8px;">${this.state?.CPRGeneData?.CNV_del_Resistant_Expanded}</td>
            <td style="border: 1px solid black; padding: 8px;">${this.state?.CPRGeneData?.CNV_del_Sensitive_Expanded}</td>
          </tr>
        </tbody>
      </table>` : '',
    
    mutation_Resistant_Expanded ? `
      <div>
        <div style="font-family:'Arial',sans-serif; font-size: 12px; text-decoration: underline; font-weight: bold;">Gene Mutation:</div>
        <div style="font-family:'Arial',sans-serif; font-size: 12px;">Resistant genes 1) had significantly more mutations (p < 0.05, Chi-squared tests), 2) differentially expressed at mRNA or protein level (p < 0.05, two-sample t-tests) with no conflict in resistant NSCLC cell lines. Similarly, sensitive genes were 1) had significantly more mutations (p < 0.05, Chi-squared tests), 2) differentially expressed at mRNA or protein level (p < 0.05, two-sample t-tests) with no conflict in sensitive NSCLC cell lines (DepMap 2023; Nusinow et al. 2020).</div>
      </div>` : '',
    
    mutation_Resistant_Expanded ? `
      <table style="width: 100%; border-collapse: collapse; word-wrap: break-word; table-layout: fixed;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px; font-weight: bold; max-width: 50%; overflow-wrap: break-word;">Resistant Genes</th>
            <th style="border: 1px solid black; padding: 8px; font-weight: bold; max-width: 50%; overflow-wrap: break-word;">Sensitive Genes</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="border: 1px solid black; padding: 8px; max-width: 50%; overflow-wrap: break-word;">${this.state?.CPRGeneData?.mutation_Resistant_Expanded}</td>
            <td style="border: 1px solid black; padding: 8px; max-width: 50%; overflow-wrap: break-word;">${this.state?.CPRGeneData?.mutation_Sensitive_Expanded}</td>
          </tr>
        </tbody>
      </table>` : '',
    
    methylation_Resistant_Expanded ? `
      <div>
        <div style="font-family:'Arial',sans-serif; font-size: 12px; text-decoration: underline; font-weight: bold;">CpG Sites with DNA Methylation:</div>
        <div style="font-family:'Arial',sans-serif; font-size: 12px;">Resistant genes 1) had more DNA methylations at CpG sites, 2) were expressed significantly higher at mRNA or protein level (p < 0.05, two-sample t-tests) with no conflict in resistant NSCLC cell lines. Similarly, sensitive genes 1) had more DNA methylations at CpG sites, 2) were expressed significantly higher at mRNA or protein level (p < 0.05, two-sample t-tests) with no conflict in sensitive NSCLC cell lines. DNA methylation data were categorized in two ways (Luo et al. 2020): 1) Unmethylated site (RRBS ≤ 0.2), Full-methylated site (RRBS ≥ 0.75), and Middle-methylated site (0.2 < RRBS < 0.75); 2) with a single cutoff of 0.6. DNA methylations associated with drug sensitivity were identified based on two criteria: 1) for continuous DNA methylation RRBS values, significant difference in sensitive versus resistant NSCLC cell lines (p < 0.05; two-sample t-tests), and 2) for categorized DNA methylation data, significant association between methylation status and drug sensitivity/resistance (p < 0.05, Chi-squared tests) (DepMap 2023; Nusinow et al. 2020).</div>
      </div>` : '',
    
    methylation_Resistant_Expanded ? `
      <table style="width: 100%; border-collapse: collapse; word-wrap: break-word; table-layout: fixed;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px; font-weight: bold; max-width: 50%; overflow-wrap: break-word;">Resistant CpG Sites</th>
            <th style="border: 1px solid black; padding: 8px; font-weight: bold; max-width: 50%; overflow-wrap: break-word;">Sensitive CpG Sites</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="border: 1px solid black; padding: 8px; max-width: 50%; overflow-wrap: break-word;">${this.state?.CPRGeneData?.methylation_Resistant_Expanded}</td>
            <td style="border: 1px solid black; padding: 8px; max-width: 50%; overflow-wrap: break-word;">${this.state?.CPRGeneData?.methylation_Sensitive_Expanded}</td>
          </tr>
        </tbody>
      </table>` : '',
    
    fusion_Resistant_Expanded ? `
      <div>
        <div style="font-family:'Arial',sans-serif; font-size: 12px; text-decoration: underline; font-weight: bold;">Gene Fusions:</div>
        <div style="font-family:'Arial',sans-serif; font-size: 12px;">Resistant genes 1) had significantly more fusions (p < 0.05, Chi-squared tests), 2) differentially expressed at mRNA or protein level (p < 0.05, two-sample t-tests) with no conflict in resistant NSCLC cell lines. Similarly, sensitive genes were 1) had significantly more fusions (p < 0.05, Chi-squared tests), 2) differentially expressed at mRNA or protein level (p < 0.05, two-sample t-tests) with no conflict in sensitive NSCLC cell lines (DepMap 2023; Nusinow et al. 2020).</div>
      </div>` : '',
    
    fusion_Resistant_Expanded ? `
      <table style="width: 100%; border-collapse: collapse; word-wrap: break-word; table-layout: fixed;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px; font-weight: bold; max-width: 50%; overflow-wrap: break-word;">Resistant Genes</th>
            <th style="border: 1px solid black; padding: 8px; font-weight: bold; max-width: 50%; overflow-wrap: break-word;">Sensitive Genes</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="border: 1px solid black; padding: 8px; max-width: 50%; overflow-wrap: break-word;">${this.state?.CPRGeneData?.fusion_Resistant_Expanded}</td>
            <td style="border: 1px solid black; padding: 8px; max-width: 50%; overflow-wrap: break-word;">${this.state?.CPRGeneData?.fusion_Sensitive_Expanded}</td>
          </tr>
        </tbody>
      </table>` : '',
    
    (this.state?.CPRGeneData?.miRNA_Sensitive?.length > 0 || this.state?.CPRGeneData?.miRNA_Resistant?.length > 0) ? `
      <div>
        <div style="font-family:'Arial',sans-serif; font-size: 12px; text-decoration: underline; font-weight: bold;">microRNA:</div>
        <div style="font-family:'Arial',sans-serif; font-size: 12px;">Resistant miRNAs were expressed significantly higher (p < 0.05; two-sample t-tests; FDR < 0.25) in resistant versus sensitive NSCLC cell lines. Similarly, sensitive miRNAs were expressed significantly higher (p < 0.05; two-sample t-tests; FDR < 0.25) in sensitive versus resistant NSCLC cell lines.</div>
      </div>` : '',
    
    (this.state?.CPRGeneData?.miRNA_Sensitive?.length > 0 || this.state?.CPRGeneData?.miRNA_Resistant?.length > 0) ? `
      <table style="width: 100%; border-collapse: collapse; word-wrap: break-word; table-layout: fixed;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px; font-weight: bold; max-width: 50%; overflow-wrap: break-word;">Resistant miRNAs</th>
            <th style="border: 1px solid black; padding: 8px; font-weight: bold; max-width: 50%; overflow-wrap: break-word;">Sensitive miRNAs</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="border: 1px solid black; padding: 8px; max-width: 50%; overflow-wrap: break-word;">${miRNAResistantData}</td>
            <td style="border: 1px solid black; padding: 8px; max-width: 50%; overflow-wrap: break-word;">${miRNASensitiveData}</td>
          </tr>
        </tbody>
      </table>` : '',
    
    ...this.state.base64Images.map(base64Image => `
      <div> 
        <span>${base64Image?.description} </span>
        <img src="${base64Image?.base64}" alt="Image" style="width: 100%; margin-bottom: 10px;" />
      </div>
    `)
  ];
}


  downloadFile = (fileUrl, name) => {

        this.setState({ loader: true })
        fetch(fileUrl)
            .then(response => response.blob())
            .then(blob => {
                saveAs(blob, name)
                this.setState({ loader: false })
            }
            )
            .catch((error) => { 
                console.error('Error downloading file:', error)
                 showErrorToast(
                            "Error downloading file"
                          );
                 this.setState({ loader: false })
            });
           
    };



  renderHTMLReferenceCheck = (content) => {
    const processed = References.reduce((acc, reference) => {
      const citationHTML = `<span class="citation-link" style="color:#376faa;cursor:pointer" onclick="document.getElementById('reference-${reference.id}')?.scrollIntoView({ behavior: 'smooth', block: 'start' })">${reference.citation}</span>`;
      const escapedCitation = reference.citation.replace(
        /[.*+?^${}()|[\]\\]/g,
        "\\$&"
      );
      return acc.replace(new RegExp(escapedCitation, "g"), citationHTML);
    }, content);

    // Subscript IC50/EC50
    const finalHTML = processed.replace(
      /(IC|EC)50/g,
      (_, prefix) => `${prefix}<sub>50</sub>`
    );

    return <div dangerouslySetInnerHTML={{ __html: finalHTML }} />;
  };

  render() {
    return (
      <div>
        <ToastContainer />
            <div className="discovery-sections mt-3">
                      <div className="drug-subtitle mb-3">
                        Characteristics of Patient Responders
                      </div>
                      <div>
                        {(this.state?.CPRGeneData?.mRNA_Sensitive?.length > 0 ||
                          this.state?.CPRGeneData?.mRNA_Resistant?.length > 0 ||
                          this.state?.CPRGeneData?.CNV_amp_Resistant?.length >
                            0 ||
                          this.state?.CPRGeneData?.CNV_amp_Sensitive?.length >
                            0 ||
                          this.state?.CPRGeneData?.CNV_del_Resistant?.length >
                            0 ||
                          this.state?.CPRGeneData?.CNV_del_Sensitive?.length >
                            0 ||
                          this.state?.CPRGeneData?.methylation_Resistant
                            ?.length > 0 ||
                          this.state?.CPRGeneData?.methylation_Sensitive
                            ?.length > 0 ||
                          this.state?.CPRGeneData?.miRNA_Resistant?.length >
                            0 ||
                          this.state?.CPRGeneData?.miRNA_Sensitive?.length >
                            0 ||
                          this.state.CPRData?.length > 0 ||
                          this.state.drugData?.responder_detail?.url) && (
                          <div className="drug-subContainerCPR">
                            <div className="drug-subtitle mb-1">
                              Drug Sensitivity Classification:
                            </div>
                            <div className="description-text">
                              {this
                                .renderHTMLReferenceCheck(`Cell lines were classified as resistant if their half-maximal inhibitory concentration (IC50) or half-maximal effective concentration (EC50)
                     values of the studied drug exceeded the maximum dose (10 µm); conversely, cell lines were classified as sensitive if their IC50 or EC50
                     values of the studied drug were below the minimum dose (0.0006 µm). Utilizing the mean ± 0.5 standard deviations of the drug
                     sensitivity measurements, the remaining cell lines were categorized into three groups: sensitive, partial response, or resistant (Ye,
                     Mohamed, et al. 2021; Ye, Singh, et al. 2021).`)}
                            </div>
                          </div>
                        )}
                        {(this.state?.CPRGeneData?.mRNA_Sensitive?.length > 0 ||
                          this.state?.CPRGeneData?.mRNA_Resistant?.length > 0 ||
                          this.state?.CPRGeneData?.CNV_amp_Resistant?.length >
                            0 ||
                          this.state?.CPRGeneData?.CNV_amp_Sensitive?.length >
                            0 ||
                          this.state?.CPRGeneData?.CNV_del_Resistant?.length >
                            0 ||
                          this.state?.CPRGeneData?.CNV_del_Sensitive?.length >
                            0 ||
                          this.state?.CPRGeneData?.methylation_Resistant
                            ?.length > 0 ||
                          this.state?.CPRGeneData?.methylation_Sensitive
                            ?.length > 0 ||
                          this.state?.CPRGeneData?.miRNA_Resistant?.length >
                            0 ||
                          this.state?.CPRGeneData?.miRNA_Sensitive?.length >
                            0) && (
                          <div className="drug-subContainerCPR">
                            <div className="drug-subtitle mb-1">
                              Genes Associated with Drug Sensitivity and
                              Resistance:
                            </div>
                            {(this.state?.CPRGeneData?.mRNA_Sensitive?.length >
                              0 ||
                              this.state?.CPRGeneData?.mRNA_Resistant?.length >
                                0) && (
                              <>
                                <div className="drug-subtitle mb-1">
                                  Genes with concordant mRNA and protein
                                  expression:
                                </div>
                                <div className="description-text">
                                  {this
                                    .renderHTMLReferenceCheck(`Resistant genes were expressed significantly higher at both mRNA and protein level (p &lt; 0.05; two-sample t-tests) in resistant versus
                     sensitive NSCLC cell lines. Similarly, sensitive genes were expressed significantly higher at both mRNA and protein level (p &lt; 0.05;
                     two-sample t-tests) in sensitive versus resistant NSCLC cell lines (DepMap 2023; Nusinow et al. 2020).`)}
                                </div>
                                <table className="drugPage-Table">
                                  <tr>
                                    <td style={{ width: "50%" }}>
                                      Resistant Genes
                                    </td>
                                    <td style={{ width: "50%" }}>
                                      Sensitive Genes
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                          
                                          <GeneList data={this.state?.CPRGeneData?.mRNA_Resistant} />

                                    </td>
                                    <td>
                                
                                          <GeneList data={this.state?.CPRGeneData?.mRNA_Sensitive} />

                                    </td>
                                  </tr>
                                </table>
                              </>
                            )}

                            {(this.state?.CPRGeneData?.CNV_amp_Resistant
                              ?.length > 0 ||
                              this.state?.CPRGeneData?.CNV_amp_Sensitive
                                ?.length > 0 ||
                              this.state?.CPRGeneData?.CNV_del_Resistant
                                ?.length > 0 ||
                              this.state?.CPRGeneData?.CNV_del_Sensitive
                                ?.length > 0) && (
                              <>
                                <div className="drug-subtitle mb-1">
                                  DNA Copy Number Variation:
                                </div>
                                <div className="description-text">
                                  {this
                                    .renderHTMLReferenceCheck(`Resistant genes were 1) amplified, 2) expressed significantly higher at protein level, and 3) had no conflict at mRNA level in resistant
                     NSCLC cell lines. Similarly, sensitive genes were 1) amplified, 2) expressed significantly higher at protein level, and 3) had no conflict at
                     mRNA level in sensitive NSCLC cell lines (DepMap 2023; Nusinow et al. 2020). Copy number values were represented as log 2 (copy
                     number ratio + 1). The data were further categorized into amplification (copy number ratio ≥ 1.5), deletion (copy number ratio ≤ 0.5),
                     and normal (0.5 &lt; copy number ratio &lt; 1.5). DNA copy number variations associated with drug sensitivity were identified based on two
                     criteria: 1) for continuous copy number data, significant difference in sensitive versus resistant NSCLC cell lines (p &lt; 0.05; two-sample
                     t-tests), and 2) for categorized copy number data, significant association between amplification/deletion and drug sensitivity/resistance
                     (p &lt; 0.05, Chi-squared tests).`)}
                                </div>
                                <table className="drugPage-Table">
                                  <tr>
                                    <td style={{ width: "33%" }}>CNV</td>
                                    <td style={{ width: "33%" }}>
                                      Resistant Genes
                                    </td>
                                    <td style={{ width: "34%" }}>
                                      Sensitive Genes
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div className="drugPage_geneTableData">
                                        Amplification
                                      </div>
                                    </td>
                                    <td>
                                 
                                          <GeneList data={this.state?.CPRGeneData?.CNV_amp_Resistant} />

                                    </td>
                                    <td>
                                   
                                          <GeneList data={this.state?.CPRGeneData?.CNV_amp_Sensitive} />

                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div className="drugPage_geneTableData">
                                        Deletion
                                      </div>
                                    </td>
                                    <td>
                                 
                                          <GeneList data={this.state?.CPRGeneData?.CNV_del_Resistant} />

                                    </td>
                                    <td>
                                  
                                          <GeneList data={this.state?.CPRGeneData?.CNV_del_Sensitive} />

                                    </td>
                                  </tr>
                                </table>
                              </>
                            )}

                            {(this.state?.CPRGeneData?.mutation_Resistant
                              ?.length > 0 ||
                              this.state?.CPRGeneData?.mutation_Sensitive
                                ?.length > 0) && (
                              <>
                                <div className="drug-subtitle mb-1">
                                  Gene Mutation:
                                </div>
                                <div className="description-text">
                                  {this
                                    .renderHTMLReferenceCheck(`Resistant genes 1) had significantly more mutations (p &lt; 0.05, Chi-squared tests), 2) differentially expressed at protein level (p &lt; 0.05,
                     two-sample t-tests), and 3) had no conflict at mRNA level in resistant NSCLC cell lines. Similarly, sensitive genes were 1) had
                     significantly more mutations (p &lt; 0.05, Chi-squared tests), 2) differentially expressed at protein level (p &lt; 0.05, two-sample t-tests), and
                     3) had no conflict at mRNA level in sensitive NSCLC cell lines (DepMap 2023; Nusinow et al. 2020).`)}
                                </div>
                                <table className="drugPage-Table">
                                  <tr>
                                    <td style={{ width: "50%" }}>
                                      Resistant Genes
                                    </td>
                                    <td style={{ width: "50%" }}>
                                      Sensitive Genes
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                     
                                          <GeneList data={this.state?.CPRGeneData?.mutation_Resistant} />

                                    </td>
                                    <td>
                                  
                                          <GeneList data={this.state?.CPRGeneData?.mutation_Sensitive} />

                                    </td>
                                  </tr>
                                </table>
                              </>
                            )}

                            {(this.state?.CPRGeneData?.methylation_Resistant
                              ?.length > 0 ||
                              this.state?.CPRGeneData?.methylation_Sensitive
                                ?.length > 0) && (
                              <>
                                <div className="drug-subtitle mb-1">
                                  CpG Sites with DNA Methylation:
                                </div>
                                <div className="description-text">
                                  {this
                                    .renderHTMLReferenceCheck(`Resistant genes 1) had more DNA methylations at CpG sites, 2) were expressed significantly higher at protein level (p &lt; 0.05, two-
                     sample t-tests), and 3) had no conflict at mRNA level in resistant NSCLC cell lines. Similarly, sensitive genes 1) had more DNA
                     methylations at CpG sites, 2) were expressed significantly higher at protein level (p &lt; 0.05, two-sample t-tests), and 3) had no conflict at
                     mRNA level in sensitive NSCLC cell lines. DNA methylation data were categorized in two ways (Luo et al. 2020): 1) Unmethylated site
                     (RRBS ≤ 0.2), Full-methylated site (RRBS ≥ 0.75), and Middle-methylated site (0.2 &lt; RRBS &lt; 0.75); 2) with a single cutoff of 0.6. DNA
                     methylations associated with drug sensitivity were identified based on two criteria: 1) for continuous DNA methylation RRBS values,
                     significant difference in sensitive versus resistant NSCLC cell lines (p &lt; 0.05; two-sample t-tests), and 2) for categorized DNA
                     methylation data, significant association between methylation status and drug sensitivity/resistance (p &lt; 0.05, Chi-squared tests)
                     (DepMap 2023; Nusinow et al. 2020).`)}
                                </div>
                                <table className="drugPage-Table">
                                  <tr>
                                    <td style={{ width: "50%" }}>
                                      Resistant CpG Sites
                                    </td>
                                    <td style={{ width: "50%" }}>
                                      Sensitive CpG Sites
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                   
                                          <GeneList data={this.state?.CPRGeneData?.methylation_Resistant} />

                                    </td>
                                    <td>
                                 
                                          <GeneList data={this.state?.CPRGeneData?.methylation_Sensitive} />

                                    </td>
                                  </tr>
                                </table>
                              </>
                            )}
                            {(this.state?.CPRGeneData?.fusion_Resistant
                              ?.length > 0 ||
                              this.state?.CPRGeneData?.fusion_Sensitive
                                ?.length > 0) && (
                              <>
                                <div className="drug-subtitle mb-1">
                                  Gene Fusions:
                                </div>
                                <div className="description-text">
                                  {this
                                    .renderHTMLReferenceCheck(`Resistant genes 1) had significantly more fusions (p &lt; 0.05, Chi-squared tests), 2) differentially expressed at protein level (p &lt; 0.05,
                     two-sample t-tests), and 3) had no conflict at mRNA level in resistant NSCLC cell lines. Similarly, sensitive genes were 1) had
                     significantly more fusions (p &lt; 0.05, Chi-squared tests), 2) differentially expressed at protein level (p &lt; 0.05, two-sample t-tests), and 3)
                     had no conflict at mRNA level in sensitive NSCLC cell lines (DepMap 2023; Nusinow et al. 2020).`)}
                                </div>
                                <table className="drugPage-Table">
                                  <tr>
                                    <td style={{ width: "50%" }}>
                                      Resistant Genes
                                    </td>
                                    <td style={{ width: "50%" }}>
                                      Sensitive Genes
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                  
                                          <GeneList data={this.state?.CPRGeneData?.fusion_Resistant} />

                                    </td>
                                    <td>
                                    
                                          <GeneList data={this.state?.CPRGeneData?.fusion_Sensitive} />

                                    </td>
                                  </tr>
                                </table>
                              </>
                            )}
                            {(this.state?.CPRGeneData?.miRNA_Resistant?.length >
                              0 ||
                              this.state?.CPRGeneData?.miRNA_Sensitive?.length >
                                0) && (
                              <>
                                <div className="drug-subtitle mb-1">
                                  microRNA:
                                </div>
                                <div className="description-text">
                                  {this
                                    .renderHTMLReferenceCheck(`Resistant miRNAs were expressed significantly higher (p &lt; 0.05; two-sample t-tests; FDR &lt; 0.25) in resistant versus sensitive NSCLC
                     cell lines. Similarly, sensitive miRNAs were expressed significantly higher (p &lt; 0.05; two-sample t-tests; FDR &lt; 0.25) in sensitive versus
                     resistant NSCLC cell lines (DepMap 2023).`)}
                                </div>
                                <table className="drugPage-Table">
                                  <tr>
                                    <td style={{ width: "50%" }}>
                                      Resistant miRNAs
                                    </td>
                                    <td style={{ width: "50%" }}>
                                      Sensitive miRNAs
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                               
                                          <GeneList data={this.state?.CPRGeneData?.miRNA_Resistant} />

                                    </td>
                                    <td>
                                  
                                          <GeneList data={this.state?.CPRGeneData?.miRNA_Sensitive} />
                                    </td>
                                  </tr>
                                </table>
                              </>
                            )}
                          </div>
                        )}

                        {this.state.CPRData?.length > 0 && (
                          <div className="drug-subContainerCPR">
                            {this.state.CPRData?.map((list) => {
                              if (
                                list?.expanded_y?.toLowerCase() ==
                                "no"
                              ) {
                                return (
                                  <>
                                    <div className="drug-desc">
                                      {this.renderHTMLReferenceCheck(
                                        list?.description
                                      )}
                                    </div>
                                    <div className="CPR-imgConatiner">
                                      <img
                                        className="CPR-img"
                                        src={list?.base64}
                                        alt=""
                                      />
                                    </div>
                                  </>
                                );
                              }
                            })}
                          </div>
                        )}

                        {!(
                          this.state?.CPRGeneData?.mRNA_Sensitive?.length > 0 ||
                          this.state?.CPRGeneData?.mRNA_Resistant?.length > 0 ||
                          this.state?.CPRGeneData?.CNV_amp_Resistant?.length >
                            0 ||
                          this.state?.CPRGeneData?.CNV_amp_Sensitive?.length >
                            0 ||
                          this.state?.CPRGeneData?.CNV_del_Resistant?.length >
                            0 ||
                          this.state?.CPRGeneData?.CNV_del_Sensitive?.length >
                            0 ||
                          this.state?.CPRGeneData?.methylation_Resistant
                            ?.length > 0 ||
                          this.state?.CPRGeneData?.methylation_Sensitive
                            ?.length > 0 ||
                          this.state?.CPRGeneData?.miRNA_Resistant?.length >
                            0 ||
                          this.state?.CPRGeneData?.miRNA_Sensitive?.length >
                            0 ||
                          this.state.CPRData?.length > 0 ||
                          this.state.drugData?.responder_detail?.url
                        ) && "N/A"}

                        {(this.state?.CPRGeneData?.mRNA_Sensitive_Expanded !=
                          "N/A" ||
                          this.state?.CPRGeneData?.mRNA_Resistant_Expanded !=
                            "N/A" ||
                          this.state?.CPRGeneData?.CNV_amp_Resistant_Expanded !=
                            "N/A" ||
                          this.state?.CPRGeneData?.CNV_amp_Sensitive_Expanded !=
                            "N/A" ||
                          this.state?.CPRGeneData?.CNV_del_Resistant_Expanded !=
                            "N/A" ||
                          this.state?.CPRGeneData?.CNV_del_Sensitive_Expanded !=
                            "N/A" ||
                          this.state?.CPRGeneData
                            ?.methylation_Resistant_Expanded != "N/A" ||
                          this.state?.CPRGeneData
                            ?.methylation_Sensitive_Expanded != "N/A" ||
                          this.state?.CPRGeneData?.miRNA_Sensitive?.length >
                            0 ||
                          this.state?.CPRGeneData?.miRNA_Resistant?.length >
                            0) && (
                          <div className="item">
                            <Button
                              className="m-0 p-0"
                              color="link"
                              onClick={this.exportPdf}
                            >
                              Expanded Gene List
                            </Button>
                          </div>
                        )}

                        {this.state.drugData?.responder_detail
                          ?.url && (
                          <div className="item">
                            <Button
                              className="m-0 p-0"
                              color="link"
                              onClick={() => {
                                this.downloadFile(
                                  `${this.state.drugData?.responder_detail?.url}`,
                                  this.state.drugData
                                    ?.responder_detail?.name
                                );
                              }}
                            >
                              Detailed information
                            </Button>
                          </div>
                        )}
                      </div>
                  </div>


        {this.state.loader && (
          <div className="backdrop">
            <div className="loader">
              <Loader type="ball-pulse-rise" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(CharacteristicsOfPatientResponders);
